import { EntityListItemResponse } from '@ydistri/api-sdk';
import { useStableParams } from '../../../../routes/useStableParams';
import { getEntityListItemDetailLink } from '../entityListsLib';

/**
 * Constructs a link to the Detail screen for the given entity list item which can
 * be either product or sku.
 * @param item - The entity list item representing either a product or Sku
 * @returns string link to the detail page or undefined if not possible
 */
const useCreateEntityListItemDetailLink = (item: EntityListItemResponse): string | undefined => {
  const { projectShortName, slug } = useStableParams();
  return getEntityListItemDetailLink(item, projectShortName, slug);
};

export default useCreateEntityListItemDetailLink;
